import { useState, useEffect, useCallback } from 'react';
const useTimer = (initialTime) => {
    const [time, setTime] = useState(initialTime);
    const [isComplete,setIsComplete]=useState(false)
    const resetTimer = useCallback(() => {
        setTime(initialTime);
        setIsComplete(false)
    }, [initialTime]);

    useEffect(() => {
        if (time === 0) {
            setIsComplete(true)
            return;
        }

        const timer = setInterval(() => {
            setTime((prevTime) => prevTime - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [time, isComplete]);

    return { time,resetTimer, isComplete };
};

export default useTimer;